const downsizeCurrencySymbols = () => {
    const priceItems = document.querySelectorAll('.price-item, .totals__total-value, .cart-subtotal__price, .data-cart-item-regular-price, .price-item--regular');
    priceItems.forEach((priceItem) => {
        if (priceItem.classList.contains('downsized')) return;
        var originalText = priceItem.innerText;
        var newText = originalText.replace(/¥/g, '<span class="mini-symbol">¥</span>'); 
        priceItem.innerHTML = newText;
        priceItem.classList.add('downsized');
    });
}

window.addEventListener('DOMContentLoaded', (event) => {
    const observer = new MutationObserver(function() {
        observer.disconnect();
        downsizeCurrencySymbols(); 
        observer.observe(elem, config);
    });

    const config = {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true
    };

    
        downsizeCurrencySymbols ();
});